const startPage: Record<string, Record<string, string> | string> = {
    logoAlt: 'Direction NTP',
};

export default startPage;
